import React, { KeyboardEventHandler } from 'react';
import { Field, FieldProps, FormikHandlers } from 'formik';
import { InputBase } from '@brighterion/br-ui';

type FormikInputFieldProps = {
    className?: string;
    disabled?: boolean;
    handleBlur: FormikHandlers['handleBlur'];
    handleChange: FormikHandlers['handleChange'];
    handleKeyDown?: KeyboardEventHandler;
    id?: string;
    label?: string;
    name: string;
    optionalMsg?: string;
    type?: string;
    min?: number;
    max?: number;
    step?: number;
    overrideValue?: string;
    dataTestId?: string;
    placeholder?: string;
};

export const FormikInputField = ({
    className,
    disabled,
    handleBlur,
    handleChange,
    id,
    label,
    name,
    optionalMsg,
    handleKeyDown,
    overrideValue,
    dataTestId,
    ...rest
}: FormikInputFieldProps) => {
    return (
        <Field name={name}>
            {({ field, meta }: FieldProps) => (
                <InputBase
                    dataTestId={dataTestId ?? name}
                    className={className}
                    disabled={disabled}
                    error={!!(meta.touched && meta.error)}
                    errorMsg={meta.error?.toString()}
                    id={id ?? name}
                    label={label}
                    name={name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    size='sm'
                    optionalMsg={optionalMsg}
                    value={overrideValue ?? field.value ?? ''}
                    onKeyDown={handleKeyDown}
                    allowPan
                    {...rest}
                />
            )}
        </Field>
    );
};

export default FormikInputField;
